export default function SVG_Polyline() {
  return (
    <div>
      <h1>SVG_Polyline Component</h1>
    </div>
  );
}
